import { preference } from 'vue-preferences';
// var port_1 = '8989' ;
// const port_2 = '8900' ;
// export const apiUrl = 'http://localhost:'+port_2+'/api/v1/'; //Lien du web service
// export const apiUrl = "https://backoffice-apaym.weblogy.net/apis/api/v1/" ; // URL DEV
// export const apiUrl = "https://backoffice.apaym.com/apis/api/v1/" ; // URL PROD
export const apiUrl = "https://carte.abidjan.net/pro/" ;// "https://applicarte.abidjan.net/v2/"; //"https://backoffice.apaym.com/apis/admin/v1/" ; // URL PROD
export const apiUrlOld = "https://applicarte.abidjan.net/test/weblogyService/Controllers/tbl_client.ctrl.php?task="; // URL PROD OLD
export const apiUrlTwilio = "https://applicarte.abidjan.net/weblogyService/Controllers/sendSmsTwilio.php";
// export const adminRoot = '/apaym';
// export const locale = preference('locale', { defaultValue: 'en' });
export const _token = preference('_token');
export const _change_pwd = preference('_change_pwd');
export const _rules = preference('_rules');
export const _wby = preference('_wby');
export const _wby_ = preference('_wby_');
export const _reference = preference('_reference');